import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { CONFERENCE_ROOM_REQUEST } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, PUT, DELETE } = HTTP_METHODS;
const { GET_ROOMS, POST_ROOM, PUT_ROOM, DELETE_ROOM, GET_BOOKINGS, POST_BOOKING, DELETE_BOOKING } =
  CONFERENCE_ROOM_REQUEST;

export const conferenceRoomApi = createApi({
  reducerPath: 'conferenceRoomApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  tagTypes: ['Rooms', 'Bookings'],

  endpoints: (builder) => ({
    getRooms: builder.query({
      query: (data) => ({ url: `${GET_ROOMS}${buildQueryString(data || {})}`, method: GET }),
      providesTags: ['Rooms']
    }),
    addRoom: builder.mutation({
      query: (data) => ({ url: POST_ROOM, method: POST, data }),
      invalidatesTags: ['Rooms']
    }),
    editRoom: builder.mutation({
      query: (data) => ({ url: `${PUT_ROOM}/${data?.id}`, method: PUT, data: data.data }),
      invalidatesTags: ['Rooms']
    }),
    deleteRoom: builder.mutation({
      query: (id) => ({ url: `${DELETE_ROOM}/${id}`, method: DELETE }),
      invalidatesTags: ['Rooms']
    }),

    getBookings: builder.query({
      query: (data) => ({ url: `${GET_BOOKINGS}${buildQueryString(data || {})}`, method: GET }),
      providesTags: ['Bookings']
    }),
    addBooking: builder.mutation({
      query: (data) => ({ url: POST_BOOKING, method: POST, data }),
      invalidatesTags: ['Bookings']
    }),
    deleteBooking: builder.mutation({
      query: (id) => ({ url: `${DELETE_BOOKING}/${id}`, method: DELETE }),
      invalidatesTags: ['Bookings']
    })
  })
});

export const {
  useGetRoomsQuery,
  useAddRoomMutation,
  useEditRoomMutation,
  useDeleteRoomMutation,
  useGetBookingsQuery,
  useAddBookingMutation,
  useDeleteBookingMutation
} = conferenceRoomApi;
